import React from 'react';

import Text from '/component/base/Text';

import {styles} from './Code.style';

interface HeadingProps {
  children: string;
}

export const Heading: React.FC<HeadingProps> = ({children = 'Heading'}) => (
  <Text style={styles.base}>{children}</Text>
);

export default Heading;
